import { render, staticRenderFns } from "./Aktivitaetenliste.vue?vue&type=template&id=22ab2ce6"
import script from "./Aktivitaetenliste.vue?vue&type=script&lang=js"
export * from "./Aktivitaetenliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports